var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresentationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 97,
    viewBox: "0 0 75 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2744 3V3C44.6933 3 47.0131 3.96134 48.723 5.67235L69.6682 26.6315C71.1349 28.0992 71.9588 30.0892 71.9588 32.1641V32.1641M42.2744 3H12.47C7.1708 3 2.875 7.29582 2.875 12.595V83.5978C2.875 88.8969 7.17082 93.1927 12.47 93.1927H62.3638C67.663 93.1927 71.9588 88.8969 71.9588 83.5978V32.1641M42.2744 3V22.5691C42.2744 27.8683 46.5702 32.1641 51.8693 32.1641H71.9588",
    stroke: "#292D32",
    strokeWidth: 5.75698
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1406 49.0557H56.2629",
    stroke: "#292D32",
    strokeWidth: 3.83799,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 49.0557H52.6478V72.5351H23.75V49.0557Z",
    stroke: "#292D32",
    strokeWidth: 3.83799,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4027 56.2803L40.918 60.7956L36.4027 65.3108M30.9844 79.7597L38.2088 72.5353L45.4333 79.7597",
    stroke: "#292D32",
    strokeWidth: 3.83799,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationIcon);
export default __webpack_public_path__ + "static/media/presentation-icon.edbcabdc5b527a12fcafa27c93600cf5.svg";
export { ForwardRef as ReactComponent };